
import { Invoice } from '../types/invoiceForm';
import { useDispatch } from 'react-redux';
import {useInvoices  } from '../hooks/useInvoices';
import { ColumnConfig, GenericTable } from './shared/GenericTable.';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateRandomNumbr } from '../utils/randomNumbers';
import { Button } from 'react-bootstrap';



interface InvoiceListProps {
  invoices: Invoice[];
}

const InvoiceList: React.FC<InvoiceListProps> = ({ invoices }: { invoices: Invoice[] }) => {
  const { t } = useTranslation();
  const {copyInvoice, removeInvoice} = useInvoices();
  const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    //pagination
    const itemsPerPage = 16;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedInvoices = invoices.slice(startIndex, endIndex);
    const totalPages = Math.ceil(invoices.length / itemsPerPage);
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;
    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  const handleOnView = (invoice: Invoice) => {
    navigate(`/detail/${invoice?.id}`, {state: {type: 'invoice'}})
  }

  const handleOnEdit = (invoice: Invoice) => {
    navigate(`/edit/${invoice?.id}`, {state: {type: 'invoice'}})
  }

  const handleOnCopy = (invoice: Invoice) => {
    if(invoice?.id){
      const id = generateRandomNumbr();
      const newInvoice = {
        ...invoice,
        id: id,
      }
      copyInvoice(invoice.id as number, newInvoice as Invoice)
    }
  }

  const handleOnDelete = (invoice: Invoice) => {
    removeInvoice(invoice.id as number)
  }

  const invoiceColumns: ColumnConfig<Invoice>[] = [
    { label: t('id'), accessor: 'id' },
    { label: t('invoiceNumber'), accessor: 'invoiceNumber' },
    { label: t('customerName'), accessor: 'to' },
    { label: t('amount'), accessor: 'total' },
  ];

  return (
    <>
      <GenericTable
        data={paginatedInvoices}
        columns={invoiceColumns}
        onView={(invoice: Invoice) => handleOnView(invoice)}
        onEdit={(invoice: Invoice) => handleOnEdit(invoice)}
        onCopy={(invoice: Invoice) => handleOnCopy(invoice)}
        onDelete={(invoice: Invoice) => handleOnDelete(invoice)}
      />

      <div className="pagination">
              <Button
                className="pagination-button"
                variant='outline-secondary'
                onClick={() => handlePageChange(1)}
                disabled={isFirstPage}
              >
                {t('first')}
              </Button>
              <Button
                className="pagination-button"
                variant='outline-primary'
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={isFirstPage}
              >
                {t('back')}
              </Button>
              <Button
                className="pagination-button"
                variant='outline-primary'
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={isLastPage}
              >
                {t('next')}
              </Button>
              <Button
                className="pagination-button"
                variant='outline-secondary'
                onClick={() => handlePageChange(totalPages)}
                disabled={isLastPage}
              >
                {t('last')}
              </Button>
        </div>
    </>
    
    
  );
};
export default InvoiceList;
